import { FaCloud } from "react-icons/fa";
import { useNewAgent } from "../contexts/NewAgentContext";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "hooks/useTranslation";

interface ChatButtonProps {
  isDisabled?: boolean;
}

const ChatButton = ({ isDisabled = false }: ChatButtonProps) => {
  const { newAgentId } = useNewAgent();
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!newAgentId) {
    return null;
  }

  const handleClick = async () => {
    if (!isDisabled) {
      navigate(`/chat/${newAgentId}`);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={isDisabled}
      className={`bg-violet-700 hover:bg-violet-800 mb-5 flex items-center gap-2 rounded bg-brand-800 px-8 py-2 font-semibold text-white shadow transition active:bg-brand-700 ${
        isDisabled ? "cursor-not-allowed opacity-50" : ""
      }`}
    >
      <FaCloud className="text-lg" />
      {t('agents.chatWithAgent')}
    </button>
  );
};

export default ChatButton;
